'use client';

import Logo from './logo.svg';

interface HeaderProps {
  showHeader: boolean;
}

export const Header = (props: HeaderProps) => {
  return (
    props.showHeader && (
      <div className='h-12 md:h-20  w-full bg-white flex items-center justify-center md:px-10 px-4 py-7'>
        <img src={Logo} className='w-[100px]  md:w-[150px]' />
      </div>
    )
  );
};

export default Header as React.FC<HeaderProps>;
